import {Fragment,useState,useEffect} from 'react';
import './Accordion.css';
import AccordionAccessability from './AccordionAccessability';
import Tel from '../../../dist/assets/Telephone.png';
import Mail from '../../../dist/assets/Mail.png';
import Place from '../../../dist/assets/Place.png';
import Time from '../../../dist/assets/Time.png';
import Fax from '../../../dist/assets/Fax.png';

const AccordionContactUsItem =(props) =>{
    const [isOpen,setIsOpen]= useState(false);

    const toggleItem =()=>{
        event.preventDefault();
        setIsOpen(!isOpen);
      } 

      useEffect(()=>{
        addEventListener("keydown",props.handleUserKeypress);
        return()=>{
            removeEventListener("keydown",props.handleUserKeypress);
        }
    },[]);

    return (
         <div className={'accordion-item modCard' +  (props.isOpen ? 'open' : '')} id={"wrap_" + props.WpId +"_"+props.index} key={"AccordionCategory_"+props.index}> 
        <div className="title modCard-header" id={"accHead_" + props.WpId +"_"+ props.index} >
          <h3 className="mb-0">
            <a role="button" className="btn btn-link collapsed" data-toggle="collapse" data-target={"#accColapse_" + props.WpId +"_"+ props.index} 
                aria-expanded="false" aria-controls={"accColapse_" + props.WpId +"_"+ props.index} >
              <span className="fa openclose" aria-hidden="true"></span>
              <div className="itemContactTitle">
                    <div className="title">{props.Title}</div>
              </div>
            </a>
             
          </h3> 
        </div>
        <div id={"accColapse_" + props.WpId +"_"+ props.index} className= {(props.isOpen ? "collapse show" : 'collapse')+" contactUsDetailes"} aria-labelledby={"accHead" + props.WpId +"_"+ props.index} 
            data-parent={"#modAccordion_" + props.WpId }>
            <ul className="contactUsDetailes" > 
           { props.data.map((item,index) => 
            <li className="card" key={"modCardDetailes_"+index}>
            <div>
                <div>
                    <h4>
                        {item.LinkTitle}
                    </h4>
                </div>
                <div className="margin10">
                    <img src={Tel} alt=""/>
                    <a className="d-md-none d-inline-flex" href={"tel:"+item.ModPhoneContacts}>{item.ModPhoneContacts}</a>
                    <span className="d-none d-md-inline-flex">{item.ModPhoneContacts}</span>
                </div>
                <div className="margin10">
                    <img src={Fax} alt=""/>
                    <span>{item.ModFaxContacts}</span>
                </div>
                <div className="margin10">
                    <img src={Mail} alt=""/>
                    <a href={"mailTo:"+item.ModMailContacts}>{item.ModMailContacts}</a>
                </div>
                <div className="margin10">
                    <img src={Time} alt=""/>
                    <span>{item.ModHoursContacts}</span>
                </div>
                <div className="margin10">
                    <img src={Place} alt=""/>
                    <span><a href={item.waze_Url} title={item.ModAddressContacts}>{item.ModAddressContacts}</a></span>
                </div>
            </div>
            <div className="card-footer" id={`modAccordionAccess${index}`}>
                    <AccordionAccessability data={item} key={"access_"+index} isOpen={isOpen} toggleItem={toggleItem} WpId={props.WpId}></AccordionAccessability>
            </div>
            </li>
            )
           }

            </ul>
        </div>
      </div>
    )
}


export default AccordionContactUsItem;